import clsx from 'clsx'
import { type ChangeEvent, type ClipboardEvent, useRef, useState } from 'react'

import cl from './style.module.scss'

type CodeInputProps = {
	code: string
	inputCount?: number
	disabled?: boolean
	isError?: boolean
	onChange: (code: string) => void
	onFocus?: () => void
	onBlur?: () => void
}

export const CodeInput = (props: CodeInputProps) => {
	const { code, inputCount = 4, disabled = false, isError = false, onChange, onFocus, onBlur } = props
	const inputRef = useRef<HTMLInputElement>(null)
	const [isFocused, setIsFocused] = useState(false)

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value.replace(/\D/g, '').slice(0, inputCount)
		onChange(value)
	}

	const handleFocus = () => {
		setIsFocused(true)
		onFocus?.()
	}

	const handleBlur = () => {
		setIsFocused(false)
		onBlur?.()
	}

	const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
		e.preventDefault()
		const pastedData = e.clipboardData.getData('text')
		const digits = pastedData.replace(/\D/g, '').slice(0, inputCount)
		onChange(digits)
	}

	const handleContainerClick = () => {
		inputRef.current?.focus()
	}

	return (
		<div
			className={clsx(cl.container, {
				[cl.container_error]: isError,
				[cl.container_focused]: isFocused,
				[cl.container_disabled]: disabled
			})}
			onClick={handleContainerClick}>
			<input
				ref={inputRef}
				type="text"
				inputMode="numeric"
				pattern="[0-9]*"
				autoComplete="one-time-code"
				maxLength={inputCount}
				value={code}
				onChange={handleChange}
				onFocus={handleFocus}
				onBlur={handleBlur}
				onPaste={handlePaste}
				className={cl.hiddenInput}
				aria-label="Код подтверждения"
				disabled={disabled}
			/>
			<div className={cl.digits}>
				{Array.from({ length: inputCount }, (_, index) => (
					<div
						key={index}
						className={clsx(cl.digit, {
							[cl.digit_active]: isFocused && index === code.length,
							[cl.digit_filled]: code[index]
						})}>
						{code[index] || ''}
					</div>
				))}
			</div>
		</div>
	)
}
